import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper.js';

function getApiErrorMessage(errorData, fallback = 'Failed to submit feedback') {
  if (!errorData || typeof errorData !== 'object') {
    return fallback;
  }
  if (typeof errorData.detail === 'string') {
    return errorData.detail;
  }
  if (typeof errorData.message === 'string') {
    return errorData.message;
  }
  if (typeof errorData.error === 'string') {
    return errorData.error;
  }
  if (errorData.error && typeof errorData.error.message === 'string') {
    return errorData.error.message;
  }
  return fallback;
}

export const feedbackService = {
  submitFeedback: async (feedbackData) => {
    try {
      const response = await fetchWrapper(`${API_BASE_URL}/api/v1/feedback/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedbackData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(getApiErrorMessage(errorData));
      }

      return await response.json();
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  },
};
